import { render, staticRenderFns } from "./DocumentosAsociadosNewOrEdit.vue?vue&type=template&id=73f756bd&scoped=true&"
import script from "./DocumentosAsociadosNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentosAsociadosNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosAsociadosNewOrEdit.vue?vue&type=style&index=0&id=73f756bd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f756bd",
  null
  
)

export default component.exports